import React from 'react';
import styled from 'styled-components';

import { useAppSelector } from '~/store';

import { useUploader } from '../hooks/useUploader';
import { Thumbnail } from './Thumbnail';
import { UploaderDropzone } from './UploaderDropzone';
import {
  selectCompletedUploads,
  selectPendingCount,
  selectPendingProgress,
} from '../state/selectors';

export const MAX_THUMBNAILS = 10;

const MediaManagerWrapper = styled.div`
  padding: 0 40px;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  z-index: 2;
  row-gap: 8px;

  > div:not(:nth-child(5)) {
    margin-right: 8px;
  }

  *:last-child {
    margin-right: 0 !important;
  }
`;

export const MediaManager = ({
  id,
  containerRef,
}: {
  id: string;
  containerRef: HTMLElement | null | undefined;
}) => {
  const { uploader } = useUploader({
    id,
    onUnmount: 'reset',
  });

  const completedUploads = useAppSelector((state) =>
    selectCompletedUploads(state, id)
  );
  const pendingCount = useAppSelector((state) => selectPendingCount(state, id));
  const pendingProgress = useAppSelector((state) =>
    selectPendingProgress(state, id)
  );
  const isUploading = pendingCount > 0;

  return (
    <MediaManagerWrapper id="media-manager" data-testid="media-manager">
      {completedUploads.map(
        (up) =>
          up.url && (
            <Thumbnail key={up.id} upload={up} containerRef={containerRef} />
          )
      )}
      {completedUploads.length < MAX_THUMBNAILS && (
        <UploaderDropzone
          uploader={uploader}
          isUploading={isUploading}
          uploadProgress={pendingProgress}
          activeUploadsCount={pendingCount}
          disabled={isUploading}
          multiple
          onlyAllowsVerticalVideo={false}
          withBorder
        />
      )}
    </MediaManagerWrapper>
  );
};
